import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { localeToHtmlLang, type LocaleCode } from '@/utils/locale';

export default function LanguageSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const syncLang = () => {
      document.documentElement.lang = localeToHtmlLang(i18n.language as LocaleCode);
    };

    syncLang();
  }, [i18n.language]);

  return null;
}